import { CompanySearchCondition } from 'src/entities/CompanySearchCondition.entity';
import { LicenseEntity } from 'src/entities/licenseEntity';
import { OrderSearchConditionEntity } from 'src/entities/OrderSearchCondition.entity';

/**
 * 楽観追加した行の id。サーバの id はまだ無く、取り直しで本物に置き換わる。
 * 実 id と衝突しないよう負の値にする。
 */
export const TEMP_PRESET_ID = -1;

type UpsertInput = {
  companyId: number;
  name: string;
  searchConditions: OrderSearchConditionEntity[];
};

/**
 * 保存したプリセットをセッションのキャッシュに載せる。
 *
 * Why 楽観更新: 一覧の出どころはセッション（license の config）で、API の成否を待って
 * 取り直すと保存しても数秒 画面が変わらず「効いていない」ように見える。
 */
export function upsertPresetInSession(
  session: LicenseEntity | undefined,
  { companyId, name, searchConditions }: UpsertInput,
): LicenseEntity | undefined {
  if (!session) return session;

  const current = session.company_search_conditions ?? [];
  // 保存は同名を上書きする契約（useServerFilterPresets.savePreset）。
  // 足すだけだと同じ名前が 2 つ並ぶ
  const kept = current.filter((it) => !(it.companyId === companyId && it.name === name));
  const added: CompanySearchCondition = {
    id: TEMP_PRESET_ID,
    companyId,
    // 表示に使わない（プリセットは名前だけを出す）ので空で足りる
    companyName: '',
    name,
    searchConditions,
  };

  return { ...session, company_search_conditions: [...kept, added] };
}

/** 削除したプリセットをセッションのキャッシュから外す */
export function removePresetFromSession(
  session: LicenseEntity | undefined,
  id: number,
): LicenseEntity | undefined {
  if (!session) return session;

  const current = session.company_search_conditions ?? [];
  return { ...session, company_search_conditions: current.filter((it) => it.id !== id) };
}
